import axios, { AxiosError } from 'axios';
import {
  Form,
    Link,
    useLoaderData,
    useActionData,
    useNavigate,
    redirect
  } from "react-router-dom";
import { Button, Card, Table, FileInput, Alert } from 'react-daisyui'
import { LoaderData } from '../../types/LoaderData';
import { ExclamationTriangleIcon, CheckCircleIcon } from '@heroicons/react/24/outline'


export async function loader({ params } : any) {
  const study: any = await (await axios.get(`/api/v1/study/${params.studyId}`)).data;

  return { study };
}

export async function action({ request, params } : {request: Request, params: any}) {
  // Extract formData from captured request
  const formData: FormData = await request.formData();
  const studyId = formData.getAll('studyId');
  const errors = {};
  let result: any;

  // Send Form data to correct path
  try{
    result = await axios.post(`/api/v1/participants/upload/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    });
  }catch(e: any){
    if(axios.isAxiosError(e)){
      const errors = e.response?.data.errors;
      return {errors}
    }
  }
  return {data: result.data}
}

export default function Upload() {
  // If its relevent in the future for what were doing with Lo
  const navigate = useNavigate();
  const action: any = useActionData();
  const { study } = useLoaderData() as LoaderData<typeof loader>;

  return (
      <div className='overflow-x-auto flex flex-col items-center'>

        <h1 className='text-3xl font-bold m-5'>Upload Participants to '{study.title}'</h1>
        <Form method='post' id="upload-form" encType='multipart/form-data'>
          <FileInput className='mr-2' color="primary" type='file' name='csv_file' />
          <Button type='submit' color='ghost' active={true}>Submit</Button>
          <input type='hidden' name='studyId' value={study.id}></input>
        </Form>

        <br/>

        { action?.errors ?
          <Alert
          status="error"
          icon={<ExclamationTriangleIcon className="h-10 w-10"/>}
          >
            <div className="w-full flex-row justify-between gap-2">
              <h3 className="text-lg font-bold">CSV Upload Error</h3>
              <h4>{action.errors.map((err: any) => <div>{err.message}</div>)}</h4>
            </div>
          </Alert> : null}

        { action?.data?.duplicates ?
        <Alert
        status="warning"
        icon={<ExclamationTriangleIcon className="h-10 w-10"/>}
        >
        <div className="w-full flex-row justify-between gap-2">
          <h3 className="text-lg font-bold">CSV Uploaded</h3>
          <h4>{`${action.data.participants - action.data.duplicates} participants added, ${action.data.duplicates} duplicates ignored`}</h4>
        </div>
        <Button variant="link" onClick={()=>navigate(`/studies/${study.id}`)}>View Study</Button>
        </Alert> : null}

        { action?.data?.duplicates < 1 ?
        <Alert
        status="success"
        icon={<CheckCircleIcon className="h-10 w-10"/>}
        >
        <div className="w-full flex-row justify-between gap-2">
          <h3 className="text-lg font-bold">CSV Uploaded</h3>
          <h4>{`${action.data.participants} participants added`}</h4>
        </div>
        <Button variant="link" onClick={()=>navigate(`/studies/${study.id}`)}>View Study</Button>
        </Alert> : null}
      </div>
  );
}